import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { DASHBOARD_STAT } from "./apiRoutes";

interface UseGetBomDashboardStatProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getBomDashboardStat = async (communityId: string) =>
  await axiosAuth.get(
    `${DASHBOARD_STAT(communityId)}/stats`
  );

const useGetBomDashboardStat = ({
  communityId,
  queryParams,
}: UseGetBomDashboardStatProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["bom-dashboard-stat", communityId],
    queryFn: () => getBomDashboardStat(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBomDashboardStat;
